module.exports = __webpack_public_path__ + "img/flow-11.bd2675db.png";